import { BlurredVideoBackground } from '@sparemin/blockhead';
import React, { useState } from 'react';

import Spinner from 'components/Spinner';
import {
  DEFAULT_BLURRED_VIDEO_BACKGROUND_HEIGHT,
  DEFAULT_BLURRED_VIDEO_BACKGROUND_WIDTH,
} from './constants';
import { useVideoUrl } from './ProjectPreviewModalContext';
import { block } from './utils';

export interface ProjectPreviewModalVideoProps {}

const ProjectPreviewModalVideo: React.FC<ProjectPreviewModalVideoProps> = () => {
  const [video, setVideo] = useState<HTMLVideoElement | null>(null);
  const [canPlay, setCanPlay] = useState<boolean>(false);

  const videoUrl = useVideoUrl();

  return (
    <div className={block('preview-container')}>
      {!canPlay && <Spinner />}

      <div className={block('video-wrapper', { available: canPlay })}>
        <BlurredVideoBackground
          video={video}
          width={DEFAULT_BLURRED_VIDEO_BACKGROUND_WIDTH}
          height={DEFAULT_BLURRED_VIDEO_BACKGROUND_HEIGHT}
        />

        <video
          ref={setVideo}
          src={videoUrl}
          className={block('video-preview')}
          controls
          onCanPlayThrough={() => setCanPlay(true)}
        />
      </div>
    </div>
  );
};

export default ProjectPreviewModalVideo;
